export default {
  data() {
    return {

    }
  },

  methods: {
    getCustomInfoSelect(key) {
      return this.customInfo && this.customInfo[key] && this.customInfo[key].selected;
    },
/**
 * 检查自定义信息中是否存在指定键
 * @param {string} key - 要检查的键名
 * @returns {boolean} 存在返回true，否则返回false
 */
    getCustomInfoExist(key) {
      return this.customInfo && this.customInfo[key];
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/customInfoSelect.js